import { useState } from "react"
import { useSelector } from "react-redux"
import { Adddata, db, updateRevision } from "../../data"
import { doc, getDoc } from "firebase/firestore"
import { useGeneral } from "../../context"
import { ToastSucces } from "../tools"

const VALIDATION_REJECTION_REASONS = [
    { code: "FV", label: "Factura vencida" },
    { code: "SC", label: "Sin credito" },
    { code: "RC", label: "Riesgo crediticio" },
    { code: "CHR", label: "Cheque rechazados" },
]
const VALIDATION_REJECTED_STATE = "Validacion rechazada"

export const NotificationModal = ({ closeSection, disabledBtn, autorizando, usePredefinedReasons = false }) => {

    const orderInfo = useSelector((state) => state.orderData)
    const userData = useSelector((state) => state.user)
    const [rejecting, setRejecting] = useState(false)
    const [selectedReason, setSelectedReason] = useState(VALIDATION_REJECTION_REASONS[0].code)
    const [message, setMessage] = useState("")

    const { mensajesCollectionFirebase, pedidosCollectionFirebase } = useGeneral()


    // funcion para disparar la funcion que suba a firebase
    const onRejectMsg = async (e) => {
        const name = usePredefinedReasons ? VALIDATION_REJECTED_STATE : e.target.name
        setRejecting(true)
        const docRef = doc(db, mensajesCollectionFirebase, orderInfo.UID)
        const docSnap = await getDoc(docRef)

        //numero de mensaje a agrega
        let msjNumB = docSnap.data() ? docSnap.data()[orderInfo.Num_pedido] : 0
        let msjNum = msjNumB ? Object.keys(msjNumB.Mensaje).length : 0
        const selectedReasonData = VALIDATION_REJECTION_REASONS.find((reason) => reason.code === selectedReason)
        const rejectMessage = usePredefinedReasons
            ? `${selectedReasonData.code}: ${selectedReasonData.label}${message.trim() ? `\n${message.trim()}` : ""}`
            : message
        const revisionExtraData = usePredefinedReasons
            ? {
                RejectionReasonCode: selectedReasonData.code,
                RejectionReasonLabel: selectedReasonData.label,
                RejectionReasonNote: message.trim(),
            }
            : {
                RejectionReasonCode: '',
                RejectionReasonLabel: '',
                RejectionReasonNote: '',
            }

        //estructura del mensaje
        let newMsg = {
            [orderInfo.Num_pedido]: {
                Vendedor: orderInfo.VendedorApellido,
                UID: orderInfo.UID,
                FechaDeCreacion: new Date(),
                Cliente: orderInfo.Cliente,
                MontoTotal: orderInfo.Total,
                FechaPedido: orderInfo.Fecha,
                NuevoMensaje: true,
                UltimoMensajeFecha: new Date(),
                UltimoMensajeDe: userData.Nombre + " " + userData.Apellido,
                Mensaje: {
                    [msjNum]: {
                        Index: msjNum,
                        Leido: false,
                        Asunto: usePredefinedReasons ? "Validacion Rechazada" : "Orden Rechazada",
                        Contenido: rejectMessage,
                        Fecha: new Date(),
                        User: userData.Nombre + " " + userData.Apellido,
                    }
                }
            }
        }

        try {
            await Adddata(docRef, newMsg)
            await updateRevision(
                pedidosCollectionFirebase,
                orderInfo.ID,
                userData.Apellido,
                name,
                undefined,
                revisionExtraData
            )
        } catch (error) {
            // console.log(error)
        } finally {

            setRejecting(false)
            closeSection()
            ToastSucces('Orden Rechazada')
        }
    }


    const handleMessage = ({ target }) => {
        setMessage(target.value)
    }

    return (

        <div
            className="d-flex flex-column p-1"
            name="Rechazado"
        >
            {
                usePredefinedReasons
                &&
                <select
                    className="p-1 mb-2"
                    value={selectedReason}
                    onChange={({ target }) => setSelectedReason(target.value)}
                >
                    {
                        VALIDATION_REJECTION_REASONS.map((reason) => (
                            <option key={reason.code} value={reason.code}>
                                {reason.code}: {reason.label}
                            </option>
                        ))
                    }
                </select>
            }

            <textarea
                className="p-1"
                placeholder={usePredefinedReasons ? "Observacion adicional (opcional)" : "Mensaje"}
                id="rejectMsg"
                rows="3" cols="7"
                value={message}
                onChange={handleMessage}>
            </textarea>

            <button
                name={usePredefinedReasons ? VALIDATION_REJECTED_STATE : 'Rechazado'}
                className='btn btnSend textBlack btnOrderStatus mt-3 p-1 w-100 minWMaxContent'
                type='button'
                disabled={(usePredefinedReasons ? false : message.length < 1) || rejecting || disabledBtn || autorizando}
                onClick={onRejectMsg}>
                Enviar
            </button>

        </div>
    )
}
